<template>
    <section class="relative w-full flex flex-col items-center justify-center text-white px-4 z-0">

        <!-- Header -->
        <div class="z-20">
            <div class="text-center mb-6">
                <h2 class="text-3xl font-bold">Be the First to Experience Excellence</h2>
                <p class="text-gray-400 mt-2">Join now for early access!</p>
            </div>

            <!-- Email input + button inside -->
            <div class="relative w-full max-w-md mx-auto mb-4 ">
                <InputText v-model="email" placeholder="Email" rounded
                    class="w-full border-none !p-3 pr-32 !rounded-full" />
                <Button unstyled label="Join Waitlist" class="absolute right-1 top-1 bottom-1 rounded-full px-4 bg-[image:var(--primary-gradient)] hover:bg-[image:var(--primary-gradient-reverse)]
         transition-all duration-1000 ease-in-out text-[var(--text-secondary)] "
                    @click="joinWaitlist" />
            </div>

            <p class="text-gray-400 text-sm mt-2 flex items-center gap-1 justify-center">
                <i class="pi pi-lock"></i> We respect your privacy – No spam, ever!
            </p>
        </div>

        <!-- Logo / Background Effect -->
        <div class="relative mt-16 flex items-center justify-center w-full">
            <div
                class="absolute w-[2000px] h-[2000px] -translate-y-[1055px] bg-[var(--background-primary)] rounded-full z-10">
            </div>
            <div
                class="absolute w-[2000px] h-[2000px] translate-y-[1055px] bg-[var(--background-primary)] rounded-full z-10">
            </div>
            <div class="absolute w-96 h-96 bg-green-400 rounded-full blur-3xl opacity-40 animate-pulse "></div>
            <div class="absolute w-96 h-96 bg-blue-400 rounded-full blur-3xl opacity-40 animate-pulse delay-200 ">
            </div>
            <div class="relative w-32 h-32 bg-gray-900 rounded-full flex items-center justify-center shadow-2xl z-10">
          <NuxtImg src="/logos/nuxtstore-logo.svg" alt="Nuxt Store Logo" width="70" height="70" loading="lazy" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">

const email = ref('')

const joinWaitlist = () => {
    if (!email.value) return alert('Please enter email')
    alert(`Joined waitlist with ${email.value}`)
    email.value = ''
}
</script>
